export default __webpack_public_path__ + "static/media/arr.1e38bdbb.svg";